<template>
	<b-card
		class="position-relative"
		:style="mobileCard && 'height: unset;'"
		:class="[getClass, { suspendcards: type === 'suspended' }]"
	>
		<section>
			<div class="kanban-card-inner-first">
				<div
					class="d-flex position-absolute outer-tag w-100 justify-content-end"
				>
					<div
						class="label-common int-in-hrs text-white fs-12 fw-M fam-mont"
						v-if="
							level == 1 &&
							timeRemaining &&
							timeRemaining != 'ongoing' &&
							interview.panelMeetingStatus != 0 &&
							showRescheduled()
						"
					>
						{{ timeRemaining }}
					</div>
					<div
						v-if="interview.panelMeetingStatus == 0"
						class="label-common int-cancelled text-white fs-12 fw-M fam-mont"
					>
						Cancelled
					</div>
					<div
						v-else-if="level == 1 && showRescheduleText()"
						class="label-common reschedule-req text-white fs-12 fw-M fam-mont"
					>
						Reschedule Requested
					</div>
					<div
						v-else-if="level == 1 && showRescheduled()"
						class="label-common rescheduled-req text-white fs-12 fw-M fam-mont"
					>
						Rescheduled
					</div>
					<div
						class="label-common int-in-hrs text-white fs-12 fw-M fam-mont"
						v-else-if="
							level != 2 &&
							timeRemaining &&
							timeRemaining != 'ongoing' &&
							interview.panelMeetingStatus != 0 &&
							!showRescheduled()
						"
					>
						{{ timeRemaining }}
					</div>
					<div
						v-else-if="interview.outOfPrefenence"
						class="label-common out-of-prefs text-white fs-12 fw-M fam-mont"
					>
						Out of Preferences
					</div>
				</div>
				<div class="d-flex justify-content-between align-items-center">
					<section style="width: calc(100% - 60px)">
						<article class="id-tag text-3A3C40">
							<span class="text-blue">ID:</span>
							{{ interview.interviewRequestID }}
						</article>
						<div class="d-flex align-items-center w-100 gap-2 mt-2">
							<div
								:class="
									interview.image
										? 'common-sm-profile-transparet-icon'
										: 'common-sm-profile-icon'
								"
							>
								<b-avatar
									v-if="interview.image"
									:src="interview.image"
								></b-avatar>
								<b-avatar v-else :text="getUserIcon(interview.name)"></b-avatar>
							</div>
							<div class="fs-14 fw-LM fam-lato color-3a3c40 w-75 text-truncate">
								{{ formattedData(interview.name) }}
							</div>
						</div>
					</section>
					<section class="d-flex gap-2 align-items-center">
						<img
							class="pointer"
							src="../../assets/paneldashboard/viewIcon.svg"
							@click="$emit('show-jobdetails', timeRemaining)"
							alt
						/>
						<img
							class="pointer"
							src="../../assets/paneldashboard/downloadIcon.svg"
							alt
							@click="downloadResume()"
						/>
						<div class="position-relative d-flex align-items-center">
							<img
								v-if="
									level == 1 &&
									!interview.panelMeetingStatus == 0 &&
									timeRemaining !== 'ongoing'
								"
								class="pointer three-dot-icon"
								src="../../assets/paneldashboard/three-dot.svg"
								alt
								@click.stop="toggleMenu"
							/>
							<transition name="fade">
								<div
									v-if="showMenu"
									v-closable="{
										exclude: ['three-dot-icon'],
										handler: 'toggleMenu',
									}"
									class="three-dot-menu position-absolute pointer fam-lato fs-13 text-3A3C40 fw-500"
								>
									<div
										@click="
											showReschedule() ? $emit('reschedule-interview') : ''
										"
										:class="!showReschedule() && 'opac-5'"
										class="menu-item fw-500 d-flex align-items-center add-gap"
										v-b-tooltip.hover.top="
											showReschedule() == null ? 'Cannot reschedule as the interview starts in less than 15 minutes' : !showReschedule() ? 'Already rescheduled' : ''
										"
									>
										<img
											src="../../assets/paneldashboard/reschedule.svg"
											alt=""
										/>
										Re-Schedule
									</div>
									<div
										class="menu-item d-flex align-items-center add-gap w-100"
										@click="cancelMeeting"
									>
										<img src="../../assets/paneldashboard/cancel.svg" alt="" />
										Cancel Meeting
									</div>
								</div>
							</transition>
						</div>
					</section>
				</div>
				<!-- here should be a small king of popup -->
				<div></div>
				<div class="d-flex justify-content-between mt-2">
					<article class="id-tag text-darkgrey">
						{{ getFormattedTime(interview) }}
					</article>
					<article
						v-b-tooltip.hover.bottom="
							getAmountToolTip(level, interview.paymentStatus)
						"
						class="rupee-tag d-flex align-items-center gap-2 fam-mont fw-M color-3a3c40"
					>
						<img :src="getRupeeImage(level, interview)" alt />
						{{ interview.amount ? interview.amount : 0 }}
					</article>
				</div>
			</div>
			<hr style="border-top: 1px solid #8c8c8c" class="my-2" />
			<div class="kanban-card-inner-second">
				<div class="d-flex align-items-center">
					<span class="fam-lato fs-12 fw-LM color-727478">Job Name:</span>
					<div class="fam-mont color-3a3c40 fw-M fs-12 text-truncate w78">
						&nbsp;&nbsp;{{ formattedData(interview.jobName) }}
					</div>
				</div>
				<!-- <div>
						<span class="fam-lato fs-12 fw-LM color-727478"> Role: </span>
						<span class="fam-mont color-3a3c40 fw-M fs-12 text-truncate">
							&nbsp;&nbsp;{{formattedData(interview.role)}}
						</span>
			</div>-->
				<div class="d-flex align-items-center mt-1">
					<span class="fam-lato fs-12 fw-LM color-727478">Skills:</span>
					<div class="fam-mont color-3a3c40 fw-M fs-12 text-truncate w78">
						&nbsp;&nbsp;{{ formattedArray(interview.skills).join(", ") }}
					</div>
				</div>
				<div
					v-if="level != 2 && interview.panelMeetingStatus != 0"
					class="w-100 d-flex align-items-center mt-1 gap-3"
				>
					<div
						class="mob-cancelBtn w-50"
						v-if="!(level === 1 && timeRemaining !== 'ongoing')"
					>
						<b-button
							@click="
								level == 0
									? $emit('accept-reject', false)
									: level == 1 && timeRemaining == 'ongoing'
									? goToFeedback()
									: $emit('cancel-interview')
							"
							class="w-100"
							style="padding: 3px 15px"
							>{{
								level == 0
									? "Reject"
									: level == 1 && timeRemaining == "ongoing"
									? "Give Feedback"
									: "Cancel Meeting"
							}}</b-button
						>
					</div>
					<div
						v-if="
							!(
								interview.interviewInfo.reschedule &&
								interview.interviewInfo.reschedule.requested &&
								level == 1
							)
						"
						class="mob-addBtn position-relative w-50 ml-auto"
						:class="level === 1 && timeRemaining !== 'ongoing' ? 'w-100' : ''"
					>
						<b-button
							@click="
								level == 0
									? $emit('accept-reject', true)
									: openMeetingLink(interview.meetingLink)
							"
							style="padding: 4px 15px"
							class="w-100"
							>{{ level == 0 ? "Accept" : "Join Meeting" }}</b-button
						>
					</div>
				</div>
				<div
					v-else-if="interview.panelMeetingStatus != 0"
					class="d-flex align-items-center justify-content-end mt-1"
				>
					<div class="mob-addBtn position-relative w-50 ml-2">
						<b-button
							style="padding: 4px 15px"
							class="w-100"
							@click="
								interview.status == 2 ? $emit('view-feedback') : goToFeedback()
							"
							>{{
								interview.status == 2 ? "View Feedback" : "Give Feedback"
							}}</b-button
						>
					</div>
				</div>
			</div>
		</section>
	</b-card>
</template>
<script>
import {
	downloadResume,
	formattedData,
	getRupeeImage,
	openMeetingLink,
	isWithinTwoHours,
	getFormattedTime,
	getAmountToolTip,
	formattedArray,
	getUserIcon,
	showReschedule,
	showRescheduleText,
	showRescheduled,
} from "../PanelDasboard/panelHelpers";
import { mapGetters } from "vuex";

export default {
	name: "InterviewRequestCard",
	props: {
		interview: Object,
		level: Number,
		isLaptop: Boolean,
		type: String,
	},
	data() {
		return {
			timeRemaining: null,
			intervalId: null,
			showMenu: false,
		};
	},
	mounted() {
		this.updateInterviewTimes();
		this.startAutoUpdate();
	},
	beforeDestroy() {
		clearInterval(this.intervalId); // Stop interval when component is destroyed
	},
	computed: {
		...mapGetters("userVUEX", {
			userInfo: "getUserInfo",
		}),
		mobileCard() {
			return this.$route.name == "PanelInterviews";
		},
		getClass() {
			let classVal = null;
			if (
				this.mobileCard &&
				this.interview.panelMeetingStatus != 0 &&
				!this.interview.outOfPrefenence
			)
				classVal = "mt-1";
			else if (
				(this.mobileCard &&
					(this.interview.panelMeetingStatus == 0 ||
						this.interview.outOfPrefenence)) ||
				(!this.isLaptop &&
					!this.mobileCard &&
					(this.interview.panelMeetingStatus == 0 ||
						this.interview.outOfPrefenence))
			)
				classVal = "mt-2";
			else if (this.isLaptop && !this.mobileCard) classVal = "mt-3";
			else if (
				!this.mobileCard &&
				(this.interview.panelMeetingStatus == 0 ||
					this.interview.outOfPrefenence)
			)
				classVal = "mt-4";
			else classVal = "mt-2";
			return classVal;
		},	
	},
	methods: {
		showRescheduled() {
			return showRescheduled(this.interview, this.userInfo.userID);
		},
		showRescheduleText() {
			return showRescheduleText(this.interview, this.userInfo.userID);
		},
		showReschedule() {
			return showReschedule(this.interview, this.userInfo.userID);
		},
		cancelMeeting() {
			this.$emit("cancel-interview", this.timeRemaining);
		},
		toggleMenu() {
			this.showMenu = !this.showMenu;
		},
		getUserIcon(name) {
			return getUserIcon(name);
		},
		formattedArray(skills) {
			return formattedArray(skills);
		},
		getAmountToolTip(level, status) {
			return getAmountToolTip(level, status);
		},
		getFormattedTime(interview) {
			return getFormattedTime(interview);
		},
		startAutoUpdate() {
			// Run initially
			this.updateInterviewTimes();
			// Run every 1 minute
			this.intervalId = setInterval(() => {
				this.updateInterviewTimes();
			}, 60000);
		},
		updateInterviewTimes() {
			let timeStrimg =
				this.interview.slotStartTime + ` -${this.interview.slot.split("-")[1]}`;
			this.timeRemaining = this.isWithinTwoHours(timeStrimg); // Call function
		},
		isWithinTwoHours(time) {
			return isWithinTwoHours(time);
		},
		openMeetingLink(link) {
			openMeetingLink(link);
		},
		getRupeeImage(level, interview) {
			return getRupeeImage(level, interview);
		},
		formattedData(data) {
			return formattedData(data);
		},
		downloadResume() {
			downloadResume(this.interview);
		},
		goToFeedback() {
			let basicInfo = {
				name: this.interview.name,
				panelName: this.interview.emailID,
				formID: this.interview.interviewInfo.feedbackFormID,
				licenseKey: this.interview.licenseKey,
				interviewID: this.interview.interviewID,
			};
			this.$store.commit("candidateVUEX/setFeedbackData", basicInfo);
			this.$emit("gotofeedback");
		},
	},
};
</script>
